module.exports = __webpack_public_path__ + "static/media/007-dental.f754058d.svg";